import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import withImmutablePropsToJS from "with-immutable-props-to-js"

// components
import EnumDisplayCell from "sheets/components/cells/EnumDisplayCell"
import EnumSelectCell from "sheets/components/cells/EnumSelectCell"

// redux functions
import { alignmentTypeSearchConnection } from "shared/stakeholder/selectors"
import { patchColumnData } from "sheets/sheet-action-creators"

// a component to render AlignmentType labels instead of IDs in sheets
export const StakeholderAlignmentCell = ({
    alignmentTypes,
    editing,
    selectedAlignmentType,
    ...props
}) => {
    // if we are editing, render the select cell
    if (editing) {
        return (<EnumSelectCell
            clearable
            choices={alignmentTypes}
            item={selectedAlignmentType}
            {...props}
        />)
    // otherwise, just render the label for the enum
    } else {
        return (<EnumDisplayCell
            choices={alignmentTypes}
            item={selectedAlignmentType}
            {...props}
        />)
    }
}

StakeholderAlignmentCell.propTypes = {
    alignmentTypes: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    editing: PropTypes.bool.isRequired,
    selectedAlignmentType: PropTypes.object,
}

export default connect(alignmentTypeSearchConnection, { patchColumnData })(withImmutablePropsToJS(StakeholderAlignmentCell))
